/**
 * NotFoundPage — 404 real.
 *
 * Antes la ruta `*` de App.tsx renderizaba <HomePage />: una URL mal tipeada
 * (`/precios`, `/nosotros`) mostraba la Home sin avisar que esa página no
 * existe — malo para la confianza y para SEO (Google veía contenido duplicado
 * bajo mil URLs). Ahora esas URLs muestran esto: mensaje humano, `noindex`, y
 * caminos claros de vuelta.
 *
 * Reusa Header + Footer (mismo patrón que TherapistPage). Tokens Contexto A
 * (`modern-style.css`) vía `var(--*)` — hereda el dark mode del sitio.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Página no encontrada | Conectemos Chile</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <Header />

      <main
        id="main-content"
        style={{
          minHeight: '60vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '80px 24px',
          background: 'var(--surface-2, #F7F9FC)',
        }}
      >
        <div style={{ maxWidth: 480, width: '100%', textAlign: 'center' }}>
          <p
            style={{
              margin: 0,
              fontFamily: "var(--font-main, 'Plus Jakarta Sans', sans-serif)",
              fontSize: '4rem',
              fontWeight: 800,
              lineHeight: 1,
              color: 'var(--primary, #1E4A8F)',
            }}
          >
            404
          </p>
          <h1
            style={{
              margin: '16px 0 8px',
              fontFamily: "var(--font-main, 'Plus Jakarta Sans', sans-serif)",
              fontSize: '1.5rem',
              fontWeight: 700,
              color: 'var(--text-primary, #1A2236)',
            }}
          >
            No encontramos esta página
          </h1>
          <p
            style={{
              margin: '0 0 28px',
              fontFamily: "var(--font-secondary, 'Inter', sans-serif)",
              fontSize: '1rem',
              lineHeight: 1.6,
              color: 'var(--text-secondary, #4A5568)',
            }}
          >
            El enlace puede estar mal escrito o la página se movió. Desde acá
            podés volver al inicio o agendar tu hora directamente.
          </p>
          <div
            style={{
              display: 'flex',
              gap: 12,
              justifyContent: 'center',
              flexWrap: 'wrap',
            }}
          >
            <Link to="/" className="btn btn-primary">
              Volver al inicio
            </Link>
            <Link to="/agendar" className="btn btn-secondary">
              Agendar una hora
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
};

export default NotFoundPage;
